import axios from "axios";

/**
 * This is essentially a re-export of `isAxiosError` from the main axios package for convenience
 */
export var isAxiosError = function isAxiosError(error) {
  return axios.isAxiosError(error);
};

// re-exporting types so users don't have to consume axios directly
//# sourceMappingURL=axiosForwarding.js.map